import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store/index.js'
import './plugins/element'
import './plugins/swiper'
import './plugins/masonry'
import './plugins/title'
import './plugins/localforage'

Vue.config.productionTip = false

function IsPC() {
  var userAgentInfo = navigator.userAgent;
  var Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
  var flag = true;
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }
  return flag;
}

router.beforeEach((to, from, next) => {
  if (IsPC()) {
    next();   
  } else {
    location.href = "https://m.acegear.com/"
  }
})

router.afterEach(() => {
  document.documentElement.scrollTop = document.body.scrollTop = 0;
  window.scrollTo(0,0)
})

new Vue({
  router,
  store,
  render: h => h(App),
  mounted: () => document.dispatchEvent(new Event("x-app-rendered")),
}).$mount('#app')
